export const getDeepProperty = (obj: object, propertyPath: string) => {
    const parts = propertyPath.split('.');

    let result = obj;

    for (let i = 0; i < parts.length; i++) {
        if (!result)
            return undefined;

        result = result[parts[i]];
    }

    return result;
}


export const setDeepProperty = (obj: object, propertyPath: string, newValue: any) => {
    const parts = propertyPath.split('.');

    let subObj = obj;

    for (let i = 0; i < parts.length - 1; i++) {
        subObj = subObj[parts[i]];
    }


    if (subObj) {
        subObj[parts[parts.length - 1]] = newValue;
    }

    return obj;
}